<template>
  <div class="section">
    <div class="content" :class="{ reserve }">
      <slot name="left" />
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicSection',
  props: {
    reserve: Boolean,
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
